import { createContext as t, useContext as o } from "react";
const n = t({});
function r() {
  return o(n);
}
export {
  n as configContext,
  r as useConfig
};
